export default {
    facility: true,
    user_facilities: [],
    lcodeManufacturerWhitelist: [],
};
